import {
  DELETE_USER_ACCESS_LEVELS,
  GET_USER_ACCESS_LEVELS,
  POST_USER_ACCESS_LEVELS,
  PUT_USER_ACCESS_LEVELS,
} from "../constants/actionTypes";

const defaultState = [];
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_USER_ACCESS_LEVELS:
        return [...action.payload];
      case POST_USER_ACCESS_LEVELS:
        return [...state, action.payload];
      case PUT_USER_ACCESS_LEVELS:
        let data = [...state];
        index = data?.findIndex(
          (setting) => setting?.id === action.payload?.id,
        );
        if (index !== -1) data[index] = { ...action?.payload };
        return data;
      case DELETE_USER_ACCESS_LEVELS:
        const updatedArr = [...state].filter(
          (setting) => setting.id !== action.payload,
        );
        return [...updatedArr];
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
